import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  ${'' /* put your global css here */}

`
